import { render, staticRenderFns } from "./Depositable.vue?vue&type=template&id=67daea5f&"
import script from "./Depositable.vue?vue&type=script&lang=js&"
export * from "./Depositable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports